import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faUserPlus,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import logo from "../logo.png";
import profileImage from "../assets/images/nikita-rathod.png";
import "../assets/css/DigitalCard.css";

const CARD_DETAILS = {
  name: "Nikita Rathod",
  title: "OPERATION MANAGER",
  phoneDisplay: "+91 95372 06111",
  phoneTel: "+919537206111",
  email: "nikita.staffingmart@gmail.com",
  website: "www.staffingmart.in",
  whatsappMessage:
    "Hello, I’m looking for staff and would love to explore how your placement agency can help me find the right candidate.",
};

const SERVICES = [
  "Recruitment Services",
  "Staffing Solutions",
  "Executive Search",
  "Temporary & Contract Staffing",
  "Permanent Staffing",
  "IT Staffing",
  "Payroll Management",
  "HR Outsourcing",
  "Campus Recruitment",
  "Project-Based Hiring",
  "Training & Development",
  "Compliance & Statutory Services",
];

const CardStripe = () => (
  <div className="digital_card_stripe" aria-hidden="true" />
);

const CardFront = () => (
  <div className="digital_card_face digital_card_front_face">
    <h1>STAFFING MART</h1>
    <img
      src={profileImage}
      alt="Nikita Rathod"
      className="digital_card_profile"
    />
    <h2>{CARD_DETAILS.name}</h2>
    <p className="digital_card_title">{CARD_DETAILS.title}</p>
    <div className="digital_card_contact">
      <p>{CARD_DETAILS.phoneDisplay}</p>
      <p>{CARD_DETAILS.email}</p>
      <p>Morabhagal, Surat</p>
    </div>
    <div className="digital_card_rule" />
    <p className="digital_card_website">{CARD_DETAILS.website}</p>
    <CardStripe />
  </div>
);

const CardBack = () => (
  <div className="digital_card_face digital_card_back_face">
    <img src={logo} alt="Staffing Mart" className="digital_card_service_logo" />
    <p className="digital_card_slogan">The Right Fit. Every time</p>
    <h2>OUR SERVICES</h2>
    <ul>
      {SERVICES.map((service) => (
        <li key={service}>{service}</li>
      ))}
    </ul>
    <CardStripe />
  </div>
);

const DigitalCard = () => {
  const cardRef = useRef(null);
  const [contactSaving, setContactSaving] = useState(false);
  const [saving, setSaving] = useState(false);

  const downloadFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleAddToContact = async () => {
    if (contactSaving) return;
    setContactSaving(true);
    const vcard = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `FN:${CARD_DETAILS.name} - Staffing Mart`,
      "ORG:Staffing Mart",
      `TITLE:${CARD_DETAILS.title}`,
      `TEL;TYPE=CELL,VOICE:${CARD_DETAILS.phoneTel}`,
      `EMAIL;TYPE=WORK:${CARD_DETAILS.email}`,
      `URL:https://${CARD_DETAILS.website}`,
      "NOTE:Staffing Mart",
      "END:VCARD",
    ]
      .filter(Boolean)
      .join("\r\n");

    const filename = "Nikita-Rathod-Staffing-Mart.vcf";
    const file = new File([vcard], filename, { type: "text/vcard" });

    try {
      if (navigator.share && navigator.canShare?.({ files: [file] })) {
        await navigator.share({
          title: `${CARD_DETAILS.name} - Staffing Mart`,
          text: "Save this contact to your device",
          files: [file],
        });
      } else {
        downloadFile(file, filename);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        downloadFile(file, filename);
      }
    } finally {
      setContactSaving(false);
    }
  };

  const handleSaveCard = async () => {
    if (!cardRef.current || saving) return;
    setSaving(true);
    try {
      const canvas = await html2canvas(cardRef.current, {
        backgroundColor: "#222",
        scale: 2,
        useCORS: true,
      });
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png"),
      );
      if (blob) {
        downloadFile(blob, "Staffing-Mart-Digital-Card.png");
      }
    } catch (error) {
      console.error("Unable to save card image", error);
    } finally {
      setSaving(false);
    }
  };

  const whatsappHref = `https://wa.me/${CARD_DETAILS.phoneTel.replace(
    "+",
    "",
  )}?text=${encodeURIComponent(CARD_DETAILS.whatsappMessage)}`;

  return (
    <section className="digital_card_sec">
      <div className="digital_card_container">
        <Link to="/" className="digital_card_back">
          ← Back to home
        </Link>

        <div className="digital_card_visual">
          <CardFront />
        </div>

        <div
          className="digital_card_download_canvas"
          ref={cardRef}
          aria-hidden="true"
        >
          <CardFront />
          <CardBack />
        </div>

        <div className="digital_card_actions">
          <button
            type="button"
            className="digital_card_action"
            onClick={handleAddToContact}
            disabled={contactSaving}
          >
            <FontAwesomeIcon icon={faUserPlus} />
            {contactSaving ? "Opening..." : "Add to contact"}
          </button>
          <button
            type="button"
            className="digital_card_action"
            onClick={handleSaveCard}
            disabled={saving}
          >
            <FontAwesomeIcon icon={faDownload} />
            {saving ? "Saving..." : "Save Card"}
          </button>
          <a
            href={`tel:${CARD_DETAILS.phoneTel}`}
            className="digital_card_action"
          >
            <FontAwesomeIcon icon={faPhone} />
            Call
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="digital_card_action whatsapp"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default DigitalCard;
